import template from './hueb-seo-conversion-create.html.twig';
import './hueb-seo-conversion-create.scss';

const {Component} = Shopware;

Component.extend('hueb-seo-conversion-create', 'hueb-seo-conversion-detail', {
    template,
    inject: [
        'systemConfigApiService', 'repositoryFactory', 'cacheApiService'
    ],
    data() {
        return {
            isLoading: false,
            conversionData: null,
        };
    },

    async created() {
        this.repository = this.repositoryFactory.create('hueb_seo_config');
        await this.getConversionData();
        await this.getConfigData();

        this.onSave();
    },

    methods: {
        async getConfigData() {
            await this.systemConfigApiService.getValues(`HuebertSeoUltimate.config`).then((response) => {
                if (response) {

                }
            }).catch(() => {
                return null;
            });
        },

        async getConversionData() {
            this.isLoading = true;
            this.conversionData = await this.repository.create(Shopware.Context.api);
            this.isLoading = false;
        },

        onActiveTabChanged(activeTab) {
            if (activeTab === 'general') {
                this.modalClass = 'sw-media-modal-folder-settings--shows-overflow';
                return;
            }
            this.modalClass = '';
        },

        onSave() {
            this.repository
                .save(this.conversionData, Shopware.Context.api)
                .then(() => {
                    this.isLoading = false;
                    this.$router.push({name: 'hueb.seo.conversion.detail', params: {id: this.conversionData.id}});
                }).catch((exception) => {
                this.isLoading = false;

                this.createNotificationError({
                    title: this.$t('hueb-seo-conversion.detail.errorTitle'),
                    message: exception
                });
            });
        },
    }
});
